import React from 'react';
import { Check, Save } from 'lucide-react';

/**
 * Toast Notification Component
 * Displays success messages for quote operations
 * 
 * @param {Object} props
 * @param {string} props.type - 'success' or 'draft'
 * @param {string} props.quoteNumber - Quote number to display
 * @param {string} props.stepName - Current step name (for drafts)
 * @param {number} props.totalARR - Total ARR amount (for success)
 * @param {boolean} props.show - Whether to show the toast
 */
const Toast = ({ type, quoteNumber, stepName, totalARR, show }) => {
  if (!show) return null;

  if (type === 'success') {
    return (
      <div className="fixed top-4 right-4 z-50 bg-green-600 text-white px-6 py-4 rounded-xl shadow-lg flex items-center gap-3 animate-slide-in">
        <Check size={24} />
        <div>
          <div className="font-semibold">Quote Generated!</div>
          <div className="text-sm opacity-90">Quote #: {quoteNumber}</div>
          <div className="text-sm opacity-90">Total ARR: ${totalARR?.toLocaleString()}</div>
        </div>
      </div>
    );
  }

  if (type === 'draft') {
    return (
      <div className="fixed top-4 right-4 z-50 bg-blue-600 text-white px-6 py-4 rounded-xl shadow-lg flex items-center gap-3 animate-slide-in">
        <Save size={24} />
        <div>
          <div className="font-semibold">Draft Saved!</div>
          <div className="text-sm opacity-90">Quote #: {quoteNumber}</div>
          <div className="text-sm opacity-90">Progress saved at: {stepName}</div>
        </div>
      </div>
    );
  }

  return null;
};

/**
 * Container for multiple toast notifications
 */
export const ToastContainer = ({ 
  showSuccess, 
  showDraftSaved, 
  quoteNumber, 
  currentStepName, 
  totalARR 
}) => (
  <>
    <Toast 
      type="success" 
      show={showSuccess} 
      quoteNumber={quoteNumber} 
      totalARR={totalARR} 
    />
    <Toast 
      type="draft" 
      show={showDraftSaved} 
      quoteNumber={quoteNumber} 
      stepName={currentStepName} 
    />
  </>
);

export default Toast;
